import React from 'react';
import { Route } from 'react-router-dom';
import { useAuth } from '../packages/auth-client';
import { SuperAdminRoute } from '../components/SuperAdminRoute';
import { LegacyRedirect } from './LegacyRedirect';
import { PlatformLayout } from '../components/shell/PlatformLayout';
import { UsersPage } from '../pages/admin/UsersPage';
import { TenantsPage } from '../pages/admin/TenantsPage';
import { WebsiteTrafficPage } from '../pages/admin/WebsiteTrafficPage';
import { PlatformOverviewPage } from '../pages/admin/PlatformOverviewPage';
import { RolesPage } from '../pages/admin/RolesPage';
import { PermissionsPage } from '../pages/admin/PermissionsPage';
import { ImpersonatePage } from '../pages/admin/ImpersonatePage';
import { AuditLogPage } from '../pages/admin/AuditLogPage';
import { DesignateSuperAdminPage } from '../pages/admin/DesignateSuperAdminPage';
import { SuperAdminBillingPage } from '../pages/admin/SuperAdminBillingPage';
import { SupportInboxPage } from '../pages/admin/SupportInboxPage';

/**
 * /admin/users is the superadmin's cross-tenant directory, in the platform
 * console. Everyone else is sent to the tenant People & Access page (U24a),
 * keeping the query.
 */
function AdminUsersGate() {
    const { isSuperAdmin } = useAuth();
    return isSuperAdmin() ? <PlatformLayout /> : <LegacyRedirect to="/people" />;
}

/** Superadmin-only routes, in the platform shell. Rendered inside ProtectedRoute. */
export const platformRoutes = (
    <>
        <Route element={<SuperAdminRoute />}>
            <Route element={<PlatformLayout />}>
                <Route path="/admin/website-traffic" element={<WebsiteTrafficPage />} />
                <Route path="/admin/overview" element={<PlatformOverviewPage />} />
                <Route path="/admin/tenants" element={<TenantsPage />} />
                <Route path="/admin/tenants/:id" element={<TenantsPage />} />
                <Route path="/admin/roles" element={<RolesPage />} />
                <Route path="/admin/permissions" element={<PermissionsPage />} />
                <Route path="/admin/impersonate" element={<ImpersonatePage />} />
                <Route path="/admin/audit-logs" element={<AuditLogPage />} />
                <Route path="/admin/designate-superadmin" element={<DesignateSuperAdminPage />} />
                <Route path="/admin/billing/tenants" element={<SuperAdminBillingPage />} />
                <Route path="/admin/support" element={<SupportInboxPage />} />
            </Route>
        </Route>
        <Route element={<AdminUsersGate />}>
            <Route path="/admin/users" element={<UsersPage />} />
        </Route>
    </>
);
